module.exports = __webpack_public_path__ + "static/media/logo-external.7fd7bcbb.png";